<template>
  <div class="line-item row">
    <div class="col-6">
      <img :src="lineItem.image" :alt="lineItem.name" class="product-image img-fluid" />
    </div>
    <div class="col-18 text-small">
      <div>
        <span v-if="lineItem.quantity > 1">{{ lineItem.quantity }} × </span>
        {{ lineItem.name.substring(0, 60) }}
      </div>
      <div>
        <div
          v-for="(property, idx) in lineItem.variant.properties"
          :key="property.key + idx"
          class="text-muted"
        >
          {{ property.key }}: {{ property.value }}
        </div>
      </div>
      <div v-if="!lineItem.variant.essential" class="mb-1 text-numbers-tabular">
        {{ lineItem.variant.price | currency }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShoppingCartLineItem",
  props: {
    lineItem: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.product-image {
  max-height: $max-height-product-image-cart;
}

.line-item {
  &:not(:last-of-type) {
    margin-bottom: $spacer / 4;
  }
}
</style>
